import React from 'react';
import Button from '../../../components/Button';

const PDF = ({ locales, slug, webLink }) => {
  const link = `${window.location.origin}/portfolio/${slug}/${webLink}.pdf`;

  return (
    <div className="pdf">
      <div className="title">{locales.pdfFile.description}</div>
      <div className="bottom">
        <div className="text-wrapper">
          <div className="text">{link}</div>
        </div>
        <Button
          primary
          onClick={() => {
            window.open(link);
          }}
        >
          {locales.download}
        </Button>
      </div>
    </div>
  );
};

export default PDF;
